// @flow

import React from 'react';
import {
  TextContent,
  DropdownContent,
  RatingContent,
  ImagesContent,
} from './contents';
import type { QuestionType, QuestionContentDescriptor } from '../../types';

type Props = {
  content: QuestionContentDescriptor,
  showValidationErrors: boolean,
  onChange: (content: QuestionContentDescriptor) => void,
};

export type PluginProps = {
  content: QuestionContentDescriptor,
  showValidationErrors: boolean,
  onChange: (content: QuestionContentDescriptor) => void,
};

const getContentElementType = (type: QuestionType) => {
  switch (type) {
    case 'short-text':
    case 'long-text':
      return TextContent;
    case 'dropdown':
    case 'radio':
    case 'checkbox':
      return DropdownContent;
    case 'rating':
      return RatingContent;
    case 'images':
      return ImagesContent;
    default:
      console.warn(`Unknown question content with type ${type}`);
      return null;
  }
};

const QuestionContent = ({
  content,
  showValidationErrors,
  onChange,
}: Props) => {
  const element = getContentElementType(content.type);
  if (element != null) {
    return React.createElement(element, {
      content,
      showValidationErrors,
      onChange,
    });
  } else {
    return null;
  }
};

export default QuestionContent;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionContent.js